import config from '../../../config';
import {authFetch, checkStatus, parseHeadersAndJson} from '../../utils/http';

export default class LiveDocumentKpiService {
  getInvalidOrganisationDocumentsByIntervention(interventionId, organisationId, page = 0, size = 10) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/project/invalid-documents?interventionId=${interventionId}&organisationId=${organisationId}&page=${page}&size=${size}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        organisations: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getInvalidSubcontractorsDocumentsByOrganisation(organisationId, country, page = 0, size = 10) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/subcontractors/invalid-documents?organisationId=${organisationId}&country=${country}&page=${page}&size=${size}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        organisations: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getValidProjectDossierStatesPercentageByIntervention(organisationId, interventionId) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/project/valid-dossier-states?interventionId=${interventionId}&organisationId=${organisationId}`)
      .then(checkStatus)
      .then(value => value.json());
  }

  getValidSubcontractorsDossierStatesPercentageByUser(userId) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/subcontractors/valid-dossier-states?userId=${userId}`)
      .then(checkStatus)
      .then(value => value.json());
  }

  getValidSubcontractorsDossierStatesPercentageByOrganisation(organisationId) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/subcontractors/valid-dossier-states?organisationId=${organisationId}`)
      .then(checkStatus)
      .then(value => value.json());
  }

  getProjectDocumentsPercentageByDocumentStateByIntervention(organisationId, interventionId) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/project/documents?interventionId=${interventionId}&organisationId=${organisationId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getSubcontractorsDocumentsPercentageByDocumentStateByUser(userId, country) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/subcontractors/documents?userId=${userId}&country=${country}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getDocumentCountByState(organisationId) {
    return authFetch(`${config.documentApi}/api/v1/documentsKpi/organisations/${organisationId}/documents-states`)
      .then(checkStatus)
      .then(response => response.json());
  }
}
